import { Component, Input } from '@angular/core';

export type TTableRowPopoverConf = {
  label: string | number;
  value?: string | number;
  colSize?: number;
  type: 'TEXT_CELL' | 'ERROR_CELL' | 'DATE_CELL';
}[];

@Component({
  selector: 'monorepo-table-row-popover',
  templateUrl: './table-row-popover.component.html',
  styleUrls: ['./table-row-popover.component.scss'],
})
export class TableRowPopoverComponent {
  @Input() popoverConf!: TTableRowPopoverConf;
}
